import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle } from 'react-icons/fa';

// Employés sans contrat, sous l'effectif de l'accueil (Yros/payor_enterprise#263).
// Le serveur ne les compte que pour le mois en cours : sur un autre mois, rien.
function NoContractAlert({ count, isCurrentMonth, showEmployeesLink }) {
  const { t } = useTranslation();
  if (!isCurrentMonth || !count) return null;

  return (
    <div role="alert" className="flex items-center gap-2 rounded-lg bg-orange-50 px-2 py-1 text-sm text-orange-800" data-cy="dashboard-no-contract-alert">
      <FaExclamationTriangle size={14} className="text-orange-700 shrink-0" aria-hidden="true" />
      <span className="font-semibold flex-grow">{t('home.employeesWithoutContract', { count })}</span>
      {showEmployeesLink && (
        <Link to="/employees" className="font-semibold underline whitespace-nowrap">
          {t('home.seeEmployeeList')}
        </Link>
      )}
    </div>
  );
}

export default NoContractAlert;
